module.exports = __webpack_public_path__ + "static/media/cover-5.1b69ea3c.jpg";